import React from "react";
import { Typography, Skeleton, Box } from "@mui/material";
import EventCard from "../EventCard/EventCard";
import styles from "./EventsGrid.module.scss";

// Skeleton Card for loading state
const EventCardSkeleton = () => (
  <div className={styles.skeletonCard}>
    <Skeleton 
      variant="rectangular" 
      className={styles.skeletonImage}
      animation="wave"
    />
    <div className={styles.skeletonContent}>
      <Skeleton variant="text" width="80%" height={28} animation="wave" />
      <Skeleton variant="text" width="60%" height={20} animation="wave" />
      <Box sx={{ mt: 2 }}>
        <Skeleton variant="text" width="70%" height={18} animation="wave" />
        <Skeleton variant="text" width="50%" height={18} animation="wave" />
        <Skeleton variant="text" width="40%" height={18} animation="wave" />
      </Box>
    </div>
  </div>
);

const EventsGrid = ({
  events = [],
  loading = false,
  onRefresh,
  skeletonCount = 9,
}) => {
  // Empty state
  if (!loading && events.length === 0) {
    return (
      <div className={styles.emptyState}>
        <div className={styles.emptyIcon}>📅</div>
        <Typography variant="h6" className={styles.emptyTitle}>
          Nu există evenimente
        </Typography>
        <Typography variant="body2" className={styles.emptySubtitle}>
          Momentan nu sunt evenimente disponibile. Revino mai târziu!
        </Typography>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      {/* Events Grid */}
      <div className={styles.grid}>
        {/* Render Events */}
        {!loading && events.map((event) => (
          <EventCard
            key={event.id}
            id={event.id}
            title={event.title}
            subtitle={event.subtitle}
            date={event.date}
            startTime={event.startTime}
            location={event.location}
            county={event.county}
            participants={event.participants}
            tickets={event.tickets}
            custom={event.custom}
            customId={event.customId}
            draft={event.draft}
            description={event.description}
            image={event.image}
            isPast={event.isPast}
            onRefresh={onRefresh}
          />
        ))}

        {/* Loading Skeletons */}
        {loading && (
          <>
            {Array.from({ length: skeletonCount }).map((_, index) => (
              <EventCardSkeleton key={`skeleton-${index}`} />
            ))}
          </>
        )}
      </div>
    </div>
  );
};

export default EventsGrid;
